import { IReleaseDTO, ISubmissionCastCrewDTO } from '@/dtos';
import { get, post, remove } from './apiWrapper';

export const saveReleaseAPI = async (release: IReleaseDTO): Promise<IReleaseDTO> => {
  let submissionId;
  if (release.submission) {
    submissionId = release.submission.id;
  } else {
    throw 'No Submission Id';
  }

  const submission = await post<IReleaseDTO>(
    `/team/submission/${submissionId}/release/save`,
    release,
  );
  return submission;
};

export const removeReleaseAPI = async (release: IReleaseDTO): Promise<IReleaseDTO> => {
  let submissionId;
  if (release.submission) {
    submissionId = release.submission.id;
  } else {
    throw 'No Submission Id';
  }

  const submission = await remove<IReleaseDTO>(
    `/team/submission/${submissionId}/release/${release.id}`,
  );
  return submission;
};

export const sendEmailToTalentAPI = async (
  submissionId: string,
  castCrew: ISubmissionCastCrewDTO,
): Promise<boolean> => {
  await post(`/team/submission/${submissionId}/sendTalentEmail`, castCrew);
  return true;
};

export const getReleaseForTalenAPI = async (
  email: string,
  token: string,
): Promise<ISubmissionCastCrewDTO> => {
  const cast = await post<ISubmissionCastCrewDTO>(`/release/talent`, {
    email: email,
    token: token,
  });
  return cast;
};
